import { render } from "./RecommendersModal.vue?vue&type=template&id=64fe0e68&scoped=true"
import script from "./RecommendersModal.vue?vue&type=script&lang=js"
export * from "./RecommendersModal.vue?vue&type=script&lang=js"

import "./RecommendersModal.vue?vue&type=style&index=0&id=64fe0e68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fe0e68"]])

export default __exports__